














import Vue from 'vue';
import { ButtonModel, EntityType } from '@/types';
import EntityLockModal from '@/components/shared/EntityLockModal.vue';

export default Vue.extend({
  name: 'DocumentLock',
  props: {
    lastActivity: {
      type: Date,
      required: true
    }
  },
  methods: {
    onButtonClicked(this: any, button: ButtonModel) {
      this.$emit('buttonClicked', button.id);
    }
  },
  created(this: any) {
    this.buttons = [
      {
        caption: 'Go back',
        id: 'goBack',
        class: 'mr-2',
        icon: 'undo-alt',
        variant: 'primary'
      }
    ] as ButtonModel[];

    this.entityType = EntityType.Document;
    this.routeName = '';
    this.routeText = 'Go back';
    this.returnRouteDesc = 'previous location';
    this.storeNamespace = 'editReferencesStore';
  },
  components: {
    EntityLockModal
  }
});
